export default {
      id: "share-usage",
      viewBox: "0 0 508 508",
      url: __webpack_public_path__ + "app/svg/sprite.svg#share",
      toString: function () {
        return this.url;
      }
    }